import { useState } from "react";
import { updateInvoiceItem } from "../../api/invoiceService";

export const useUpdateInvoiceItem = (successCallback) => {
  const [updating, setUpdating] = useState(false);
  const update = async (id, data) => {
    setUpdating(true);
    try {
      const updatedRecord = await updateInvoiceItem(id, data);
      setUpdating(false);
      if (successCallback) successCallback(updatedRecord);
      return updatedRecord;
    } catch (error) {
      setUpdating(false);
      console.error("Failed to update invoice item:", error);
      throw error;
    }
  };

  return { update, updating };
};